import neighborhoodsGuideAds from '@/assets/images/neighborhoods-guide/neighborhoods-guide-ads.svg'
import zapArrow from '@/assets/images/icons/zap-arrow.svg'
import clickTracker from '@/utils/tracking/neighborhoods-guide/neighborhoods-guide-link-clicked'
import viewTracker from '@/utils/tracking/neighborhoods-guide/neighborhoods-guide-link-view'
import { POSITIONS } from '@/utils/constants'

export default {
  name: 'oz-neighborhoods-guide-ads',

  props: {
    widget: { type: Object, required: true },
  },

  data () {
    return {
      neighborhoodsGuideAds,
      zapArrow,
      title: `Quer saber como é morar em ${this.widget.name}?`,
      observeVisibilityConfig: {
        callback: this.trackOnVisible,
        once: true,
        intersection: {
          threshold: 0.25,
        },
      },
    }
  },

  computed: {
    trackingData () {
      return {
        linkLabel: this.title,
        position: POSITIONS.LISTING,
      }
    },
  },

  methods: {
    trackOnClick () {
      const { linkLabel, position } = this.trackingData
      clickTracker.linkClicked(linkLabel, position)
    },
    trackOnVisible (isVisible) {
      if (!isVisible) return
      const { linkLabel, position } = this.trackingData
      viewTracker.sectionViewed(linkLabel, position)
    },
  },
}
